import React from 'react';

import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Text } from '@uhg-abyss/web/ui/Text';

import { ErrorPageRoot } from '@/components/ErrorPageRoot/ErrorPageRoot';
import {
  ErrorPageBodyContainer,
  ErrorPageErrorContainer,
  ErrorPageMainHeaderContainer,
  ErrorPageSubHeaderContainer,
  ErrorPageSubTextContainer,
} from '@/components/ErrorPageRoot/ErrorPageRoot.styles';
import { PageBody } from '@uhg-abyss/web/ui/PageBody';
import { ErrorRefreshButton } from '@/components/ErrorRefreshButton/ErrorRefreshButton';
import { useLagoon } from '@/hooks/useLagoon';
import { InternalServerErrorConstants } from './constants';
import { formatLagoonData } from '../../utils/formatLagoonData';

export const InternalServerError = () => {
  const data = useLagoon('container-ui-messaging')() ?? [];
  const content = formatLagoonData(data, InternalServerErrorConstants);

  return (
    <PageBody>
      <ErrorPageRoot>
        <ErrorPageBodyContainer style={{ alignItems: 'flex-start' }}>
          {/* // HEADER */}
          <ErrorPageErrorContainer>
            <Text
              color="$interactive2"
              data-auto-testid="internal-server-error-title"
              data-testid="internal-server-error-title"
              fontWeight="$bold"
              size="$xs"
            >
              {content[InternalServerErrorConstants.ERROR]?.title ?? 'ERROR'}
            </Text>
          </ErrorPageErrorContainer>
          <ErrorPageMainHeaderContainer>
            <Heading>
              {content[InternalServerErrorConstants.ERROR_500_HEADER_TEXT]
                ?.title ?? "Oh no! Sorry it's not you, it's us."}
            </Heading>
          </ErrorPageMainHeaderContainer>
          <ErrorPageSubHeaderContainer>
            <Heading offset={5}>
              {content[InternalServerErrorConstants.ERROR_500_SUBHEADER_TEXT]
                ?.title ?? 'Something went wrong.'}
            </Heading>
          </ErrorPageSubHeaderContainer>

          {/* // MAIN */}
          <ErrorPageSubTextContainer
            style={{ alignItems: 'flex-start', textAlign: 'left' }}
          >
            <Text size="$sm">
              {content[InternalServerErrorConstants.ERROR_500_CONTENT_LINE_1]
                ?.title ??
                "An error has occurred and we're working to fix the problem. We'll be up and running shortly."}
            </Text>{' '}
            <br />
            <Text size="$sm">
              {content[InternalServerErrorConstants.ERROR_500_CONTENT_LINE_2]
                ?.title ??
                'If you need immediate help please call the number on the back of your card. Thanks for your patience.'}
            </Text>
            <ErrorRefreshButton
              buttonText={
                content[InternalServerErrorConstants.REFRESH]?.title ??
                'Refresh'
              }
            />
          </ErrorPageSubTextContainer>
        </ErrorPageBodyContainer>
      </ErrorPageRoot>
    </PageBody>
  );
};
